import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-[#EBEBFA] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="bg-white rounded-3xl shadow-sm p-10 md:p-14 max-w-lg w-full text-center">
        <span className="w-16 h-16 rounded-full bg-[#EBEBFA] flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-8 h-8 text-[#1A243B]" />
        </span>
        <h1 className="font-display text-3xl text-[#1A243B] mb-3" data-testid="cancel-heading">Booking not completed</h1>
        <p className="text-[#2D3748] text-base leading-relaxed mb-8">
          Your payment was cancelled and no booking was made. You can pick a date and try again whenever you're ready — or call 503-449-8323 and Julie will help.
        </p>
        <Link to="/#book" data-testid="cancel-retry-btn" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] font-bold px-8 py-3.5 rounded-full">
          Try booking again
        </Link>
      </div>
    </main>
  );
}
